import { IHelpRegistry, IHelpRepository } from "../../../domain/help";
import { HelpRepository } from ".";

export class HelpRegistry implements IHelpRegistry {
  constructor(private _getToken: () => string) {
  }

  getHelpRepository(): IHelpRepository {
    return new HelpRepository(this._getToken);
  }
}
